import { IconCheck } from "../icons/icons";
import styles from "./ConfirmMark.module.css";

const LABEL = "You're in";

/** The one authored completion moment: a confirmation mark that settles in
 * with a soft scale/fade. Re-mount with a `key` change to replay it for a
 * fresh submission. */
export function ConfirmMark() {
  return (
    <div className={styles.mark} role="img" aria-label={LABEL}>
      <span className={styles.ring}>
        <IconCheck className={styles.icon} aria-hidden="true" />
      </span>
      <span className={styles.label}>{LABEL}</span>
    </div>
  );
}
